var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-container is-clickable has-text-centered",on:{"click":function($event){return _vm.$emit('click', _vm.team)}}},[_c('div',{staticClass:"team-logo"},[_c('img',{attrs:{"src":_vm.team.logo,"alt":_vm.team.team_name}})]),_c('div',{staticClass:"team-name"},[_vm._v(" "+_vm._s(_vm.team.team_name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }